module.exports = __webpack_public_path__ + "img/table-no-data-light.a3d3f3f2.svg";